module.exports = __webpack_public_path__ + "media/aerial-farm-fullhd04.f7424408.mp4";